
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitobhimashankarcab() {



    const cardData =
    {
        keyword: ' Mumbai to Bhimashankar Cab  ',
        heading: 'Deva Cabs: Mumbai to Bhimashankar Cab  ',
        headingDescription: 'Deva Cabs provides reliable and comfortable cab services from Mumbai to Bhimashankar, ideal for spiritual trips, weekend getaways, and family travel. Located around 220 km from Mumbai, Bhimashankar is one of the revered Jyotirlinga shrines nestled in the Sahyadri hills. Our well-maintained fleet—including Sedans, SUVs, and Innova Crysta—ensures a safe and smooth ride through scenic mountain roads. With experienced drivers, fixed fares, and 24/7 service, Deva Cabs makes your Bhimashankar Yatra peaceful and hassle-free.',

        top: 'Top Places to Visit in Bhimashankar with Deva Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "location": "Bhimashankar, Pune District, Maharashtra",
    "description": "Bhimashankar Temple is one of the 12 sacred Jyotirlingas of Lord Shiva and a major pilgrimage site in Maharashtra. Located amidst the lush Sahyadri Hills, the temple features Nagara-style architecture and is believed to be where Lord Shiva defeated the demon Tripurasura. Devotees visit year-round, especially during Mahashivratri and Shravan."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "location": "Bhimashankar, Maharashtra",
    "description": "The Bhimashankar Wildlife Sanctuary surrounds the Jyotirlinga temple and is home to rare and endangered species like the Indian Giant Squirrel (Shekru). With dense forests, waterfalls, and trekking trails, it's a haven for nature lovers and bird watchers looking to explore the Western Ghats."
  },
  {
    "title": "Hanuman Lake",
    "location": "Near Bhimashankar Temple, Maharashtra",
    "description": "Hanuman Lake is a peaceful and scenic spot near the temple where devotees and visitors can relax and enjoy the serene surroundings. Surrounded by thick forest, it's perfect for quiet reflection and spotting birds and local wildlife."
  },
  {
    "title": "Gupt Bhimashankar",
    "location": "Bhimashankar, Maharashtra",
    "description": "Gupt Bhimashankar is a hidden shrine deep in the forest, said to be the original place where the Jyotirlinga first appeared. Reaching this sacred spot requires a short trek, making it a spiritually rewarding and offbeat experience for devout visitors."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "location": "Bhimashankar, Maharashtra",
    "description": "Bhimashankar offers several trekking routes through the Sahyadri range, with trails that take you through dense forests, waterfalls, and panoramic viewpoints. Popular among nature enthusiasts and trekkers, these trails add adventure to the spiritual journey."
  },
  {
    "title": "Nagphani Point (Nagfani Viewpoint)",
    "location": "Bhimashankar, Maharashtra",
    "description": "Also known as Nagfani Point, this viewpoint offers breathtaking panoramic views of the valleys and dense forests of the Western Ghats. The spot gets its name from its shape resembling a snake’s hood and is a favorite for sunrise and sunset photography."
  },
  {
    "title": "Ahupe Ghat",
    "location": "Near Bhimashankar, Maharashtra",
    "description": "Ahupe Ghat is a scenic mountain pass and trekking destination located near Bhimashankar. It offers mesmerizing views of the Konkan region and untouched landscapes. It’s a great add-on for trekkers and offbeat explorers visiting the area."
  },
  {
    "title": "Mokshakund Tirtha",
    "location": "Bhimashankar Temple Premises, Maharashtra",
    "description": "Located behind the main shrine, Mokshakund is a sacred water tank believed to have been used by ancient sages for rituals. Pilgrims consider it a spiritually powerful place for meditation and holy dips."
  },
  {
    "title": "Kamalja Devi Temple",
    "location": "Near Bhimashankar Temple, Maharashtra",
    "description": "Situated close to the Jyotirlinga shrine, this temple is dedicated to Goddess Kamalja, an incarnation of Goddess Parvati. Devotees often visit this temple after offering prayers at the main Bhimashankar temple to complete their spiritual circuit."
  },
  {
    "title": "Origin of River Bhima",
    "location": "Bhimashankar Forest Area, Maharashtra",
    "description": "The river Bhima, a major tributary of the Krishna River, originates in the forests of Bhimashankar. A small stream near the temple marks this sacred origin point, adding geographical and religious significance to the pilgrimage."
  }
],



"services": [
  {
    "name": "Mumbai to Bhimashankar Cab",
    "description": "Plan a spiritual escape to the revered Bhimashankar Jyotirlinga temple with Deva Cabs’ Mumbai to Bhimashankar cab service. Our dedicated outstation cabs ensure a smooth journey through scenic hilly terrain and forest areas. Choose from a range of vehicles suitable for solo travelers, families, or groups, and enjoy a peaceful ride to one of Maharashtra’s most sacred shrines."
  },
  {
    "name": "Book Bhimashankar taxi from Mumbai",
    "description": "Booking a Bhimashankar taxi from Mumbai is easy with Deva Cabs’ online and phone booking options. We offer instant confirmation, door-to-door pickup, and multiple vehicle choices including sedans, SUVs, and tempo travellers. Whether you’re planning a quick day trip or a night halt, we’ll ensure timely and reliable service with experienced drivers familiar with temple routes."
  },
  {
    "name": "One-way cab Mumbai to Bhimashankar",
    "description": "Looking for a one-way cab to Bhimashankar from Mumbai? Deva Cabs provides cost-effective and flexible one-way taxi solutions. Ideal for pilgrims staying overnight at Bhimashankar or continuing their journey further, our cabs come with fixed rates, clean interiors, and GPS tracking for a stress-free travel experience."
  },
  {
    "name": "Round trip Bhimashankar cab Mumbai",
    "description": "Enjoy a complete round-trip cab service from Mumbai to Bhimashankar and back, tailored for day or overnight pilgrims. With Deva Cabs, you get a dedicated vehicle and driver for the entire journey, offering you the freedom to explore en route spots, rest breaks, and return at your convenience. Perfect for families and devotional groups."
  },
  {
    "name": "AC cab hire Mumbai to Bhimashankar",
    "description": "Hire fully air-conditioned cabs for your Mumbai to Bhimashankar trip and travel in comfort. Our AC cabs are ideal for the summer months and long drives, offering you a pleasant journey amidst hilly curves and forest roads. From compact cars to spacious SUVs, we have options to suit your preferences and group size."
  },
  {
    "name": "SUV cab to Bhimashankar from Mumbai",
    "description": "Travel in a sturdy, comfortable SUV from Mumbai to Bhimashankar with Deva Cabs. Our SUV options like Ertiga, Innova, and Crysta offer high ground clearance, ample luggage space, and reclining seats — perfect for navigating the winding ghat roads en route to the temple. Ideal for groups, large families, or monsoon travelers."
  },
  {
    "name": "Chauffeur cab Mumbai to Bhimashankar temple",
    "description": "Our chauffeur-driven cab service ensures a smooth, guided trip to the Bhimashankar temple. Our professional drivers are courteous, punctual, and knowledgeable about Bhimashankar’s location and route nuances. They assist with temple entry points, parking, and return logistics, so you can focus solely on your spiritual journey."
  },
  {
    "name": "Pilgrimage cab Mumbai to Bhimashankar",
    "description": "For a devotional travel experience, choose our special pilgrimage cab to Bhimashankar from Mumbai. From vehicle cleanliness and driver etiquette to flexible temple darshan timings, everything is curated for pilgrims seeking serenity and spiritual comfort. Our service is especially suited for elders, family yatras, and religious groups."
  },
  {
    "name": "Affordable cab Bhimashankar Mumbai",
    "description": "Deva Cabs offers affordable taxi options for Mumbai to Bhimashankar trips without compromising on safety or service. Get transparent pricing, no hidden costs, and competitive rates for sedans, hatchbacks, or shared travel options. Budget-friendly, reliable, and timely — ideal for solo travelers or families looking for value."
  },
  {
    "name": "Online booking Mumbai to Bhimashankar taxi",
    "description": "Book your Mumbai to Bhimashankar cab online with ease. Our digital platform provides 24/7 booking access, real-time availability, and immediate confirmation. Choose your pickup time, vehicle type, and customize the return schedule, all from the comfort of your home. Travel confidently with trusted service and support."
  }
],
"tableData": [
  ["Mumbai to Bhimashankar Cab", "-Book Bhimashankar taxi from Mumbai"],
  ["One-way cab Mumbai to Bhimashankar", "-Round trip Bhimashankar cab Mumbai"],
  ["AC cab hire Mumbai to Bhimashankar", "-SUV cab to Bhimashankar from Mumbai"],
  ["Chauffeur cab Mumbai to Bhimashankar temple", "-Pilgrimage cab Mumbai to Bhimashankar"],
  ["Affordable cab Bhimashankar Mumbai", "-Online booking Mumbai to Bhimashankar taxi"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Bhimashankar Cab Service",
    "WhyChoosedescription": "Our Mumbai to Bhimashankar cab service offers dependable and punctual transportation to one of Maharashtra’s most revered Jyotirlinga temples. Whether you are visiting for pilgrimage, adventure, or nature exploration, we ensure a comfortable and timely journey with professional assistance from start to finish."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Scenic Hill Travel",
    "WhyChoosedescription": "Travel in our well-maintained, air-conditioned vehicles that provide ample space and comfort for the approximately 110 km journey to Bhimashankar. With ergonomic seating and sufficient luggage space, our cabs make your trip pleasant and relaxing while you enjoy the scenic routes through the Western Ghats."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Expertise in Mountain Roads",
    "WhyChoosedescription": "Our professional drivers are experienced in navigating the winding and sometimes challenging roads leading to Bhimashankar. They prioritize safety, maintain punctuality, and offer helpful local insights, ensuring you reach your destination securely and stress-free."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We provide clear pricing with no hidden fees, inclusive of tolls, fuel, and driver allowances. Our affordable rates allow you to plan your pilgrimage or excursion budget confidently, ensuring great value for your money."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cab service is available around the clock, accommodating your preferred departure times. Whether it’s an early morning journey or a late return, we offer flexibility to suit your schedule and ensure a smooth travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Bhimashankar cab is quick and hassle-free via our website or customer support. Receive instant confirmation, driver details, and fare breakdown to plan your trip confidently."
  },
  {
    "WhyChooseheading": "Safe and Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety is paramount. Our vehicles are regularly serviced and sanitized, equipped with essential safety features like seat belts and GPS tracking. Our drivers adhere to strict safety protocols, especially when navigating mountainous terrain."
  },
  {
    "WhyChooseheading": "Customized Travel Options for Your Convenience",
    "WhyChoosedescription": "We offer flexible packages including one-way trips, round trips, and stopovers. Whether traveling solo, with family, or in a group, our services are tailored to meet your itinerary and travel preferences for a stress-free experience."
  }
]










    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Bhimashankar with Deva Cabs?",
    answer: "Yes, Deva Cabs offers safe and comfortable cab services from Mumbai to Bhimashankar for pilgrimage, trekking, and nature trips."
  },
  {
    question: "How long is the journey from Mumbai to Bhimashankar by cab?",
    answer: "The travel time is approximately 4 to 5 hours, depending on traffic and road conditions."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Bhimashankar trip?",
    answer: "We offer a variety of options such as sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit individual and group needs."
  },
  {
    question: "Can I book a one-way cab to Bhimashankar from Mumbai?",
    answer: "Yes, Deva Cabs offers affordable one-way cab services without return fare charges."
  },
  {
    question: "Is it safe to travel to Bhimashankar with Deva Cabs?",
    answer: "Absolutely. All our drivers are background-verified and trained, ensuring a safe and pleasant experience for all travelers."
  },
  {
    question: "Are tolls and parking fees included in the cab fare?",
    answer: "Toll and parking charges are usually additional and will be clearly communicated at the time of booking."
  },
  {
    question: "Can I schedule my pickup early in the morning or late at night?",
    answer: "Yes, Deva Cabs operates 24/7, so you can plan your trip according to your preferred timing."
  },
  {
    question: "Is this trip suitable for senior citizens and families?",
    answer: "Yes, the route and our vehicles are suitable for senior citizens and family travel with comfortable and safe rides."
  },
  {
    question: "Can I book a round trip from Mumbai to Bhimashankar?",
    answer: "Yes, you can choose a round-trip package with flexible return options based on your temple visit and sightseeing plans."
  },
  {
    question: "Why choose Deva Cabs for a Mumbai to Bhimashankar cab service?",
    answer: "Deva Cabs offers clean vehicles, courteous drivers, transparent pricing, and on-time service for a smooth pilgrimage experience."
  }
];

const testimonialData = [
  {
    id: 49,
    name: 'Mr. Anil Pawar',
    role: 'Devotee',
    review: 'We booked Deva Cabs for a spiritual trip to Bhimashankar. The car was clean, the journey was safe, and the driver was very helpful. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 50,
    name: 'Ms. Neeta Patil',
    role: 'Family Traveler',
    review: 'Our Mumbai to Bhimashankar cab was smooth and well-organized. Deva Cabs made the whole trip hassle-free for our family.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-bhimashankar-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Bhimashankar cab with Deva Cabs. Get affordable and comfortable AC, SUV, and chauffeur-driven cabs for one-way or round-trip to Bhimashankar Temple. Easy online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "875"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5600",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-bhimashankar-cab" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Pilgrimage Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Bhimashankar cab with Deva Cabs. Affordable and comfortable AC, SUV, and chauffeur-driven taxi for one-way and round trip to Bhimashankar Temple. Online booking available." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Bhimashankar Cab, Book Bhimashankar taxi from Mumbai, One-way cab Mumbai to Bhimashankar, Round trip Bhimashankar cab Mumbai, AC cab hire Mumbai to Bhimashankar, SUV cab to Bhimashankar from Mumbai, Chauffeur cab Mumbai to Bhimashankar temple, Pilgrimage cab Mumbai to Bhimashankar, Affordable cab Bhimashankar Mumbai, Online booking Mumbai to Bhimashankar taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitobhimashankarcab;